import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SidenavService } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy } from '@ngneat/until-destroy';
import Debug from 'debug';
import { Subscription } from 'rxjs';
import { Constants } from '../../../../../aumico-lib-core-fe/src/lib/constants/constants';
import { LocalStorageService } from '../../../../../aumico-lib-core-fe/src/lib/services/localStorage.service';
import { animateText, onMainContentChange, onSideNavChange } from './../../animations/animations';

const debug = Debug('aumico:aumico-layout:AppSideNav');

@UntilDestroy()
@Component({
    selector: 'app-aumico-side-nav',
    templateUrl: './app-sidenav.component.html',
    styleUrls: ['./app-sidenav.component.scss'],
    animations: [onMainContentChange, onSideNavChange, animateText],
})
export class AppSideNav implements OnInit, OnDestroy {
    // If initial true, it will be open
    public sideNavState = true;
    private subscriptions: Subscription[] = new Array<Subscription>();

    // If initial true, it will be open
    constructor(
        private sidenavService: SidenavService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private localStorageService: LocalStorageService,
    ) {
        this.addSvgIcon('dashboard');
        this.addSvgIcon('heart');
        this.addSvgIcon('menu-close');
        this.addSvgIcon('logout');
        this.addSvgIcon('aumico-pattern-icon-add-circle');
        this.addSvgIcon('aumico-pattern-icon-remove-circle');
        this.addSvgIcon('aumico-pattern-icon-info');
        this.addSvgIcon('aumico-pattern-icon-alert-info');
        this.addSvgIcon('aumico-pattern-icon-settings-vertical');
        this.addSvgIcon('aumico-pattern-icon-arrow-up');
        this.addSvgIcon('aumico-pattern-icon-arrow-down');
        this.addSvgIcon('aumico-pattern-icon-arrow-right');
        this.addSvgIcon('aumico-pattern-icon-arrow-left');
        this.addSvgIcon('aumico-pattern-icon-view-off');
        this.addSvgIcon('aumico-pattern-icon-view-on');
        this.addSvgIcon('aumico-pattern-icon-filter');
        this.addSvgIcon('aumico-pattern-icon-outlook');
        this.addSvgIcon('aumico-pattern-icon-gmail');
        this.addSvgIcon('aumico-pattern-icon-yahoo');
        this.addSvgIcon('aumico-pattern-icon-clients');
        this.addSvgIcon('aumico-pattern-icon-annualreports');
        this.addSvgIcon('aumico-pattern-icon-companies');
        this.addSvgIcon('aumico-pattern-icon-buildings-1');
        this.addSvgIcon('aumico-pattern-icon-users-1');
        this.addSvgIcon('aumico-pattern-icon-settings-1');
        this.addSvgIcon('aumico-pattern-icon-reload');
        this.addSvgIcon('aumico-pattern-icon-add-nocircle');
        this.addSvgIcon('aumico-pattern-icon-data-file-check');
        this.addSvgIcon('aumico-pattern-icon-fcp');
        this.addSvgIcon('aumico-side-menu-close-icon');
        this.addSvgIcon('aumico-side-menu-open-icon');
    }

    ngOnInit() {
        this.checkAndSwitchSidebar();
        this.subscriptions.push(
            this.sidenavService.sideNavState$.subscribe((res) => {
                debug('sidenavService.sideNavState$', res);
                this.sideNavState = res;
                if (this.sideNavState) {
                    this.localStorageService.setSideNavCollapsedKey('1');
                } else {
                    this.localStorageService.setSideNavCollapsedKey('0');
                }
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    private checkAndSwitchSidebar(): void {
        if (this.localStorageService.isKeyInLocalStorage(Constants.SIDE_NAV_STATE_COLLAPSED_KEY)) {
            const sidebarStatus = this.localStorageService.getItem(Constants.SIDE_NAV_STATE_COLLAPSED_KEY);
            const value = Boolean(Number(sidebarStatus));
            this.sideNavState = value;
            this.sidenavService.sideNavState$.next(value);
        }
    }

    private addSvgIcon(name: string) {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    onSideNavToggle($event) {
        if ($event.offsetX > $event.target.offsetWidth && $event.target.localName === 'mat-sidenav') {
            this.sideNavState = !this.sideNavState;
            this.sidenavService.sideNavState$.next(this.sideNavState);
        }
    }
}
